import React from "react";
import styles from "./chip.module.scss";
import { CheckCircle, Copy } from "lucide-react";

const CodeChip = ({ code = "", copyable = true, className = "" }) => {
  const [copied, setCopied] = React.useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(code).then(() => {
      setCopied(true);
      setTimeout(() => {
        setCopied(false);
      }, 2000);
    });
  };

  return (
    <div
      className={`
        inline-flex items-center border font-mono
        text-sm px-3 py-1 rounded-md
        bg-gray-100 text-gray-800 border-gray-200
        ${styles.chip}
        ${className}
      `}
    >
      <span className="whitespace-nowrap">{code}</span>

      {copyable && (
        <button
          onClick={handleCopy}
          className="ml-2 p-1 rounded-full hover:bg-gray-200 hover:bg-opacity-30"
          aria-label="Copy code"
        >
          {copied ? <CheckCircle size={14} /> : <Copy size={14} />}
        </button>
      )}
    </div>
  );
};

export default CodeChip;
